import { appStateSelector } from '@/checkout-instore-legacy/device/selectors'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import OrderTransactionBuilder from '@/checkout-instore-legacy/transaction/order/OrderTransactionBuilder'

export function useAppStateShortCircuit() {
  const appState = useSelector(appStateSelector)
  const [previousAppState, setPreviousAppState] = useState(appState)

  useEffect(
    function shortCircuitWhenBackToActive() {
      if (appState !== previousAppState) {
        setPreviousAppState(appState)

        if (appState === 'active') {
          const orderTransaction = OrderTransactionBuilder.getCurrent()
          orderTransaction?.pooler?.pool()
        }
      }
    },
    [previousAppState, appState]
  )
}
